export default __webpack_public_path__ + "static/google-2808f15698fdc6ae24dc9edc6512d1bf.jpg";